/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overage covers pipetting loss so the last tube is still full.`)
};

const es_pcr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El exceso cubre la pérdida de pipeteo para que el último tubo quede completo.`)
};

const de_pcr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Überschuss gleicht Pipettierverluste aus, damit auch das letzte Röhrchen voll ist.`)
};

const nl_pcr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overmaat compenseert pipetteerverlies zodat het laatste buisje nog vol is.`)
};

const fr_pcr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La marge couvre les pertes de pipetage pour que le dernier tube reste plein.`)
};

const it_pcr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il margine copre le perdite di pipettaggio così l'ultima provetta resta piena.`)
};

const pt_br2_pcr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O excedente cobre a perda de pipetagem para que o último tubo fique cheio.`)
};

const pt_pcr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O excedente cobre as perdas de pipetagem para que o último tubo fique completo.`)
};

const ja_pcr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーバーヘッジはピペッティング損失を補い、最後のチューブでも十分な量を確保します。`)
};

const zh_pcr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`损耗余量用于弥补移液损失，确保最后一管仍是满量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_ex3", locale)
	if (locale === "en") return en_pcr_ex3(inputs)
	if (locale === "es") return es_pcr_ex3(inputs)
	if (locale === "de") return de_pcr_ex3(inputs)
	if (locale === "nl") return nl_pcr_ex3(inputs)
	if (locale === "fr") return fr_pcr_ex3(inputs)
	if (locale === "it") return it_pcr_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_ex3(inputs)
	if (locale === "pt") return pt_pcr_ex3(inputs)
	if (locale === "ja") return ja_pcr_ex3(inputs)
	return zh_pcr_ex3(inputs)
};